import react from "react";
import { Helmet } from 'react-helmet-async';

import boden1 from "../images/commercials/Boden/BODEN_FINAL_000 Large.jpeg";
import boden2 from "../images/commercials/Boden/BODEN_FINAL_002 Large.jpeg";
import boden3 from "../images/commercials/Boden/BODEN_FINAL_003 Large.jpeg";
import boden4 from "../images/commercials/Boden/BODEN_FINAL_004 Large.jpeg";
import boden5 from "../images/commercials/Boden/BODEN_FINAL_005 Large.jpeg";
import boden6 from "../images/commercials/Boden/0073025-0007 copy Large.jpeg";
import boden7 from "../images/commercials/Boden/BODEN_FINAL_007 Large.jpeg";
import boden8 from "../images/commercials/Boden/Boden_24WWIN_R0683_COL_W01_0861 copy Large.jpeg";
import boden9 from "../images/commercials/Boden/0073024-0004 copy Large.jpeg";
import boden10 from "../images/commercials/Boden/Boden_24WWIN_K1017_ROS_W01_1581 copy Large.jpeg";
import boden11 from "../images/commercials/Boden/BODEN_FINAL_011 Large.jpeg";
import boden12 from "../images/commercials/Boden/BODEN_FINAL_012 Large.jpeg";
import boden13 from "../images/commercials/Boden/BODEN_24GWIN_G4931_STR_W01_1146 copy Large.jpeg";
import boden14 from "../images/commercials/Boden/BODEN_FINAL_0100 Large.jpeg";
import boden15 from "../images/commercials/Boden/BODEN_24GWIN_G4931_STR_W01_1213 copy Large.jpeg"
import boden16 from "../images/commercials/Boden/0073025-0000 copy Large.jpeg";
import boden17 from "../images/commercials/Boden/Boden_24WWIN_R0683_COL_W01_0927 copy Large.jpeg";
import boden18 from "../images/commercials/Boden/BODEN_FINAL_018 Large.jpeg";
import boden19 from "../images/commercials/Boden/BODEN_FINAL_019 Large.jpeg";

const Boden = () => {
    return (
        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={boden1} alt="Boden commercial photography - image 1"/>
                </div>
                <div className="single portrait">
                    <img src={boden2} alt="Boden commercial photography - image 2"/>
                </div>
                <div className="single portrait">
                    <img src={boden3} alt="Boden commercial photography - image 3"/>
                </div>
                <div className="single portrait">
                    <img src={boden4} alt="Boden commercial photography - image 4"/>
                </div>
                <div className="single portrait">
                    <img src={boden5} alt="Boden commercial photography - image 5"/>
                </div>
                <div className="single portrait">
                    <img src={boden6} alt="Boden commercial photography - image 6"/>
                </div>
                <div className="single portrait">
                    <img src={boden7} alt="Boden commercial photography - image 7"/>
                </div>
                <div className="single portrait">
                    <img src={boden8} alt="Boden commercial photography - image 8"/>
                </div>
                <div className="single portrait">
                    <img src={boden9} alt="Boden commercial photography - image 9"/>
                </div>
                <div className="single portrait">
                    <img src={boden10} alt="Boden commercial photography - image 10"/>
                </div>
                <div className="single portrait">
                    <img src={boden11} alt="Boden commercial photography - image 11"/>
                </div>
                <div className="single portrait">
                    <img src={boden12} alt="Boden commercial photography - image 12"/>
                </div>
                <div className="single portrait">
                    <img src={boden13} alt="Boden commercial photography - image 13"/>
                </div>
                <div className="single portrait">
                    <img src={boden14} alt="Boden commercial photography - image 14"/>
                </div>
                <div className="single portrait">
                    <img src={boden15} alt="Boden commercial photography - image 15"/>
                </div>
                <div className="single portrait">
                    <img src={boden16} alt="Boden commercial photography - image 16"/>
                </div>
                <div className="single portrait">
                    <img src={boden17} alt="Boden commercial photography - image 17"/>
                </div>
                <div className="single portrait">
                    <img src={boden18} alt="Boden commercial photography - image 18"/>
                </div>
                <div className="single portrait">
                    <img src={boden19} alt="Boden commercial photography - image 19"/>
                </div>
            </div>
        </div>
    );
}

export default Boden;